// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CorrectiveMaintenanceStatisticsDto,
  InChargeOfEnum,
} from '@ellf/common-dto';
import {
  ReferenceDateFieldEnum,
  StatisticsDelayResult,
  StatisticsResult,
} from '@ellf/common-utils';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceStatisticsApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceStatisticsDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-statistics';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  getLastOpeningDate() {
    return this.http.get<Date | null>(`${this.baseUrl}/get-last-opening-date`);
  }

  createMCStatistics() {
    return this.http.post<Date>(`${this.baseUrl}/create-statistics`, {});
  }

  getStatistics(
    from: string,
    to: string,
    referenceField: ReferenceDateFieldEnum,
  ) {
    return this.http.post<StatisticsResult>(`${this.baseUrl}/get-statistics`, {
      from: from,
      to: to,
      referenceField: referenceField,
    });
  }

  getDelayStatistics(
    from: string,
    to: string,
    referenceField: ReferenceDateFieldEnum,
  ) {
    return this.http.post<StatisticsDelayResult[]>(
      `${this.baseUrl}/get-delay-statistics`,
      {
        from: from,
        to: to,
        referenceField: referenceField,
      },
    );
  }

  getCompetenceStatistics(
    from: string,
    to: string,
    referenceField: ReferenceDateFieldEnum,
    inChargeOf: InChargeOfEnum,
  ) {
    return this.http.post<StatisticsResult>(
      `${this.baseUrl}/get-competence-statistics`,
      {
        from: from,
        to: to,
        referenceField: referenceField,
        inChargeOf: inChargeOf,
      },
    );
  }
}
